import { render, staticRenderFns } from "./StaticMultiSelect.vue?vue&type=template&id=05a4e8ad&"
import script from "./StaticMultiSelect.vue?vue&type=script&lang=js&"
export * from "./StaticMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports